 <div
  class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 mt-6  shadow sm:col-span-2 md:col-span-4">
  <div
    class="flex flex-col items-start justify-between sm:flex-row">
    <div
      class="truncate text-lg font-medium leading-6 tracking-tight">
      {{'VehicleStock' | transloco}}
    </div>
    <div class="mt-3 sm:ml-2 sm:mt-0">
      <mat-button-toggle-group
        [value]="range()"
        (change)="onRangeChange($event.value)"
        #vehicleStockWeekSelector="matButtonToggleGroup">
        <mat-button-toggle value="30 days">{{'Last30Days' |
          transloco}}</mat-button-toggle>
        <mat-button-toggle value="3 months">{{'Last3Months' |
          transloco}}</mat-button-toggle>
        <mat-button-toggle value="6 months">{{'Last6Months' |
          transloco}}</mat-button-toggle>
        <mat-button-toggle value="1 year">{{'Last1Year' |
          transloco}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div
    class="mt-8 grid w-full grid-flow-row grid-cols-1 gap-6 sm:mt-4 lg:grid-cols-2">
    <div class="flex flex-auto flex-col">
      <div class="text-secondary font-medium">
        {{'Arrived' | transloco}} vs. {{'Sold' | transloco}}
      </div>
      <div class="flex flex-auto flex-col">
        <apx-chart
          class="h-80 w-full flex-auto"
          [chart]="
                                                    chartVehicleStock.chart
                                                "
          [colors]="
                                                    chartVehicleStock.colors
                                                "
          [dataLabels]="
                                                    chartVehicleStock.dataLabels
                                                "
          [grid]="chartVehicleStock.grid"
          [labels]="
                                                    chartVehicleStock.labels
                                                "
          [legend]="
                                                    chartVehicleStock.legend
                                                "
          [plotOptions]="
                                                    chartVehicleStock.plotOptions
                                                "
          [series]="
                                                    chartVehicleStock.series
                                                "
          [states]="
                                                    chartVehicleStock.states
                                                "
          [stroke]="
                                                    chartVehicleStock.stroke
                                                "
          [tooltip]="
                                                    chartVehicleStock.tooltip
                                                "
          [xaxis]="
                                                    chartVehicleStock.xaxis
                                                "
          [yaxis]="
                                                    chartVehicleStock.yaxis
                                                "></apx-chart>
      </div>
    </div>
    <!-- Overview -->
    <div class="flex flex-col">
      <div class="text-secondary font-medium">
        {{'Overview' | transloco}}
      </div>
      <div
        class="mt-6 grid flex-auto grid-cols-4 gap-4">
        <!-- New issues -->
        <div
          class="col-span-2 flex flex-col items-center justify-center rounded-2xl bg-indigo-50 px-1 py-8 text-indigo-800 dark:bg-white dark:bg-opacity-5 dark:text-indigo-400">
          <div
            class="mb-2 text-sm font-sm sm:text-lg">
            {{
            data.inStockTotalValue | currency: 'CHF'
            }}
          </div>
          <div
            class="text-5xl font-semibold leading-none tracking-tight sm:text-7xl">
            {{
            data.currentlyInStock
            }}
          </div>

          <div
            class="mt-1 text-sm font-medium sm:text-lg">
            {{'CurrentlyInStock' | transloco}}
          </div>
        </div>
        <!-- Closed -->
        <div
          class="col-span-2 flex flex-col items-center justify-center rounded-2xl bg-green-50 px-1 py-8 text-green-800 dark:bg-white dark:bg-opacity-5 dark:text-green-500">
          <div
            class="text-5xl font-semibold leading-none tracking-tight sm:text-7xl">
            {{
            data.soldVehicles
            }}
          </div>
          <div
            class="mt-1 text-sm font-medium sm:text-lg">
            {{'SoldVehicles' | transloco}}
          </div>
        </div>
        <!-- Fixed -->
        <div
          class="text-secondary col-span-2 flex flex-col items-center justify-center rounded-2xl bg-gray-100 px-1 py-8 dark:bg-white dark:bg-opacity-5 sm:col-span-1">
          <div
            class="text-5xl font-semibold leading-none tracking-tight">
            {{
            data.reserved
            }}
          </div>
          <div
            class="mt-1 text-center text-sm font-medium">
            {{'Reserved' | transloco}}
          </div>
        </div>
        <!-- Won't fix -->
        <div
          class="text-secondary col-span-2 flex flex-col items-center justify-center rounded-2xl bg-gray-100 px-1 py-8 dark:bg-white dark:bg-opacity-5 sm:col-span-1">
          <div
            class="text-5xl font-semibold leading-none tracking-tight">
            {{
            data.upcoming
            }}
          </div>
          <div
            class="mt-1 text-center text-sm font-medium">
             {{'Upcoming' | transloco}}
          </div>
        </div>
        <!-- Re-opened -->
        <div
          class="text-secondary col-span-2 flex flex-col items-center justify-center rounded-2xl bg-gray-100 px-1 py-8 dark:bg-white dark:bg-opacity-5 sm:col-span-1">
          <div
            class="text-5xl font-semibold leading-none tracking-tight">
            {{
            data.purchased
            }}
          </div>
          <div
            class="mt-1 text-center text-sm font-medium">
             {{'Purchased' | transloco}}
          </div>
        </div>
        <!-- Needs triage -->
        <div
          class="text-secondary col-span-2 flex flex-col items-center justify-center rounded-2xl bg-gray-100 px-1 py-8 dark:bg-white dark:bg-opacity-5 sm:col-span-1">
          <div
            class="text-5xl font-semibold leading-none tracking-tight">
            {{
            data.tradeIn
            }}
          </div>
          <div
            class="mt-1 text-center text-sm font-medium">
            {{'Trade In' | transloco}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

